import { redirectToHubLogin, useSession } from "@internal/auth";
import { type ReactNode, useEffect } from "react";
import { useServiceWorkerNavigation } from "@/hooks/useServiceWorkerNavigation";

export function AuthGuard({ children }: { children: ReactNode }) {
  const { user, loading } = useSession();
  useServiceWorkerNavigation();
  useEffect(() => {
    if (!loading && !user) redirectToHubLogin();
  }, [loading, user]);
  if (loading) return null;
  if (!user) return null;
  return <>{children}</>;
}
